module.exports = {
  requrl: "https://mailservice.merppi.info/api/send",
  subject: "Yhteydenotto Merppi-sivulta",
};

//requrl: "http://vps281277.ovh.net:8000/send",
//  subject: "Yhteydenotto Merppi-sivulta",
//requrl: "https://mailservice.merppi.info/api/send",
// requrl: "http://localhost:8000/send",
